import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-100/70 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
                <i className="ri-book-open-line"></i>
              </span>
              <span className="font-heading text-xl md:text-2xl text-foreground-950">
                喵趣漫画
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-md">
              喵趣漫画汇集喵趣漫画日常、喵趣漫画养猫日常、喵趣漫画生活日常与日常趣事作品，轻松日常持续更新，随时随地在线看。养猫人的日常漫画，都在这里。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950 mb-4">浏览</h3>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-700 hover:text-primary-600">首页</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-700 hover:text-primary-600">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-700 hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950 mb-4">帮助</h3>
            <ul className="space-y-2.5">
              <li><Link to="/faq" className="text-sm text-foreground-700 hover:text-primary-600">常见问题</Link></li>
              <li><span className="text-sm text-foreground-700">投稿合作</span></li>
              <li><span className="text-sm text-foreground-700">版权声明</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 喵趣漫画网 · 养猫人日常漫画都在这里
          </p>
          <p className="text-xs text-foreground-600">
            本站漫画内容为展示用途 · 联系邮箱：hello@miaoqucomic.example
          </p>
        </div>
      </div>
    </footer>
  );
}